import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-5 py-3 bg-background-50 border-2 border-foreground-200 rounded-xl text-foreground-800 font-body text-sm font-medium hover:border-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
      >
        <i className="ri-menu-line text-lg w-5 h-5 flex items-center justify-center"></i>
        <span>Kategorie</span>
        <i className={`ri-arrow-down-s-line text-lg w-5 h-5 flex items-center justify-center transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>

      {isOpen && (
        <div className="absolute top-full mt-2 left-0 w-72 bg-background-50 border border-background-200 rounded-xl overflow-hidden z-50 shadow-[0_8px_30px_rgba(0,0,0,0.08)] animate-fade-in-up">
          <div className="max-h-96 overflow-y-auto py-2">
            {categories.map((cat) => (
              <a
                key={cat.id}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-3 px-5 py-3 text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors duration-150 cursor-pointer group"
              >
                <span className="w-2 h-2 rounded-full bg-primary-400 group-hover:bg-primary-500 transition-colors flex-shrink-0"></span>
                <span className="text-sm font-medium">{cat.name}</span>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}